export default __webpack_public_path__ + "images/logo-erico.svg?360bbbb1659ed1c60df2b316c8acd47b";